import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import ModalCandidatosCsv from "./ModalCandidatosCsv";
import { THIS_URL } from "../../variables";



const CandidatosSaidas = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_candidatos, setLoadingcandidatos] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');

    const [candidatos, setcandidatos] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



    const [search, setSearch] = useState('');
    const { processo_id, processo_name } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [candidatos_id, setRedacaoId] = useState(null);


    const [questaoSelect, setQuestaoSelect] = useState({});

    const [showModal, setShowModal] = useState(false);
    let refs = [];
    const dispatch = useDispatch();

    const [loading_zip, setLoadingZip] = useState(false);
    const [message_zip, setMessageZip] = useState('');

    const [loading_zip2, setLoadingZip2] = useState(false);
    const [message_zip2, setMessageZip2] = useState('');
    const timerRef = useRef(null);


    const Getcandidatos = async (page, search) => {

        let response = await Request.Get(`faculdade/get_candidatos_saidas_tela/${processo_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.pagination.current_page == page) {

            setcandidatos(response.candidatos);

            setPagination(response.pagination);
            setLoadingScreen(false);
            setLoadingcandidatos(false);


        }
    }



    const GetRelatórioCandidato = async (user) => {

        let response = await Request.GetFile(`faculdade/get_relatorio_candidato/${processo_id}/${user.id}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }

        saveAs(response, 'relatorio_' + user.name + '.csv');

    }

    const DeleteRedacao = async (candidatos_id) => {

        let response = await Request.Delete(`faculdade/desvincular_candidato/${candidatos_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        Getcandidatos(pagination.current_page, search_oficial);



    }

    useEffect(() => {
        Getcandidatos(1, search_oficial);

        return () => {
            clearTimeout(timerRef.current)
        }
    }, []);

    const GetPdfsZip = async () => {

        let response = await Request.Get(`faculdade/download_pdfs_images/` + processo_id);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        // else if(response['status']==undefined){
        //     setLoadingZip(false);

        //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
        // }
        else {
            if (response['status'] == true) {
                document.getElementById('download_link').href = response['path'];
                document.getElementById('download_link').click();
                setLoadingZip2(false);
                setMessageZip2('');

                return;
            }
            else if (response['status'] != 'Error') {
                setMessageZip2(response['message']);
            }
            timerRef.current = setTimeout(() => {
                GetPdfsZip();
            }, 20000);

        }


    }

    const GetSaidasZip = async (user) => {

        let response = await Request.GetFile(`faculdade/get_relatorio_saidas/${processo_id}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }

        saveAs(response, 'relatorio_saidas_' + processo_id + '.csv');

    }

    let pesquisarTimeout = null;
    const history = useHistory();
    return (
        <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>

                    <p className="text-muted">Aqui ficam os candidatos ordernados por saídas da tela de avialiação do "{processo_name}"</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search className="mt-2" placeholder="Pesquisar pelo nome do candidato" ValueChange={value => {
                            clearTimeout(pesquisarTimeout);
                            setSearchOficial(value);

                            pesquisarTimeout = setTimeout(() => {
                                let page = { ...pagination };
                                page.current_page = 1;
                                setPagination(pagination);
                                setLoadingcandidatos(true);

                                Getcandidatos(1, value)

                            }, 500);
                        }} />





                        <div className=" mt-2" style={{
                            height: 'max-content',
                            justifyContent: 'flex-end'
                        }}>


                            <div className="d-flex " style={{
                                justifyContent: 'flex-end'
                            }}>








                                {<span onClick={() => {

                                    GetSaidasZip();

                                }} style={{ textDecoration: "none", marginRight: 5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Baixar relatório de saídas de tela</p></Button>}

                                </span>}
                            </div>





                        </div>

                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Saídas</th>

                                        <th>Nome</th>
                                        <th>Inscrição</th>

                                        <th>E-mail</th>
                                        <th>CPF</th>
                                        <th>Data de nascimento</th>
                                        <th>Ações</th>



                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_candidatos == false && candidatos.map((item, id) => (

                                        <tr key={id}>
                                            <td>{item.saidas}</td>

                                            <td>{item.name}</td>
                                            <td>{item.numero_inscricao}</td>

                                            <td>{item.email}</td>
                                            <td>{item.cpf}</td>
                                            <td>{moment(item.nascimento).format('DD/MM/YYYY')}</td>
                                            <td>

                                                <a target="_blank" href={`${THIS_URL}candidatos_vinculados/show/${item.id}`} onClick={(e) => e.stopPropagation()}>

                                                    <span

                                                        className="inline-flex align-center jcc bg-warning icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                        title="Gerenciar candidato"
                                                    >
                                                        <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </a>
                                            </td>
                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}



                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            {loading_candidatos == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress />
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_candidatos == false && candidatos.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhum candidato encontrado</p>

                        </div>
                    </div>}

                    <Pagination
                        className={(pagination.last_page == 1 ? "hide" : "")}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={pagination.last_page}
                        value={pagination.current_page}
                        onChange={(_, value) => {
                            setLoadingcandidatos(true);
                            console.log(_, value);
                            let page = { ...pagination };
                            page.current_page = value;
                            setPagination(pagination);
                            Getcandidatos(value, search_oficial)
                        }}
                    />

                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_candidatos={this.get_candidatos.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingcandidatos(true);
                        DeleteRedacao(candidatos_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo desvincular'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao desvincular este candidato, ele não terá mais acesso a este processo
                </SweetAlert>


            </div>

        </div>
    )
}

export default CandidatosSaidas;
